import React, { ReactNode } from 'react';
import * as styles from './index.module.less';
import Collapse from '../collapse';

interface IProps {
  answer: ReactNode | string;
  question: ReactNode | string;
  defaultOpen?: boolean;
  answerClass?: string;
  titleSuffixPart?: ReactNode;
  wrapperClass?: string;
  onChange?: (open: boolean) => void;
}

const FaqsCollapse = ({
  answer,
  question,
  defaultOpen = false,
  answerClass = '',
  titleSuffixPart,
  wrapperClass = '',
  onChange,
}: IProps) => {
  return (
    <div className={`${styles.faqs_container} ${wrapperClass}`}>
      <Collapse
        defaultOpen={defaultOpen}
        title={question}
        content={answer}
        titleClass={styles.question}
        contentClass={`${styles.answer} ${answerClass} blog-font`}
        titleSuffixPart={titleSuffixPart}
        onChange={onChange}
      />
    </div>
  );
};
export default FaqsCollapse;
